const ServicioAsignacionValoresObjetos = {

    asignarAtributosObjeto(event, _this, toUpperCase) {
      let nombrePropiedad = event.target.name;
      let valorPropiedad = event.target.value;
      if (toUpperCase) {
        if (valorPropiedad)
          valorPropiedad = valorPropiedad.toUpperCase();
      }
      
      let nombreObjetoState = nombrePropiedad.split(".")[0];
      let nombreAtributoObjetoState = nombrePropiedad.split(".")[1];
      let objeto = _this.state[nombreObjetoState];
      objeto[nombreAtributoObjetoState] = valorPropiedad;
      _this.setState({ objeto });
    }
  }
  
  export default ServicioAsignacionValoresObjetos;